import {
  type EvaluationContext,
  type EvaluationContextValue,
  OpenFeature,
  type Provider,
} from '@openfeature/web-sdk';

import { createConfidenceWebProvider } from '@spotify-confidence/openfeature-web-provider';
import { Confidence } from '@spotify-confidence/sdk';

export type FlagEvaluationAttributes = Record<
  string,
  string | boolean | number | undefined
>;

const withDefaultsOnResolutionFailure = (provider: Provider): Provider => {
  const initialize = provider.initialize?.bind(provider);
  const onContextChange = provider.onContextChange?.bind(provider);

  return Object.assign(provider, {
    initialize: async (context?: EvaluationContext, domain?: string) => {
      try {
        await initialize?.(context, domain);
      } catch {
        return;
      }
    },
    onContextChange: async (
      oldContext: EvaluationContext,
      newContext: EvaluationContext,
    ) => {
      try {
        await onContextChange?.(oldContext, newContext);
      } catch {
        return;
      }
    },
  });
};

export const bindOpenFeature = (confidence: Confidence): void => {
  OpenFeature.setProvider(
    withDefaultsOnResolutionFailure(createConfidenceWebProvider(confidence)),
  );
};

const toEvaluationContext = (
  attributes: FlagEvaluationAttributes,
): EvaluationContext => {
  const context: Record<string, EvaluationContextValue> = {};

  for (const [key, value] of Object.entries(attributes)) {
    if (value !== undefined) {
      context[key] = value;
    }
  }

  return context;
};

export const setFlagEvaluationContext = (
  attributes: FlagEvaluationAttributes,
): void => {
  OpenFeature.setContext(toEvaluationContext(attributes));
};
